// ===================

import { ReactNode, useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import ToolbarIcons from '@/icons/toolbar';
import { useLayoutContext } from '@/context/LayoutContext';

interface ModalType {
  modalKey?: string;
  modalIcon?: ReactNode;
  children: ReactNode;
  handleShowModal: () => void;
  title: string | ReactNode;
  extraContentInsideClass?: string;
  extraContentStyle?: string;
  extraHeaderStyle?: string;
  extrawrapperstyle?: string;
  contentId?: string;
  text?: string;
}

const Modal = ({
  modalKey = '',
  // modalIcon = <ToolbarIcons.NotificationIconFill />,
  modalIcon,
  children,
  handleShowModal,
  title,
  extraContentInsideClass = '',
  extraContentStyle,
  extraHeaderStyle = 'nothing',
  extrawrapperstyle = '',
  contentId = '',
  text,
}: ModalType) => {
  const { dir, isWaiting, cancelUploadMap, cancelUploadFor, resetCancelUploadFor, setIswaiting } =
    useLayoutContext();

  const [opacityHandle, setOpacityHandle] = useState(false);

  useEffect(() => {
    setTimeout(() => setOpacityHandle(true), 50);
  }, []);

  // // ✅ Close modal when its upload finishes/cancels
  // useEffect(() => {
  //   const cancelValue = cancelUploadMap[modalKey];
  //   if (cancelValue === 'done') {
  //     setIswaiting(false);
  //     resetCancelUploadFor(modalKey);
  //     handleShowModal();
  //   }
  // }, [cancelUploadMap[modalKey]]);

  //   useEffect(() => {
  //   const cancelValue = cancelUploadMap[modalKey];
  //   if (cancelValue === 'done') {
  //     // stop waiting spinner state first
  //     setIswaiting(false);

  //     // reset the key right away so future uploads are independent
  //     resetCancelUploadFor(modalKey);

  //     // close modal (call parent handler)
  //     handleShowModal();

  //     // reset opacity so animation runs next time modal opens
  //     setOpacityHandle(false);
  //   }
  // }, [cancelUploadMap[modalKey]]);

  // useEffect(() => {
  //   const cancelValue = cancelUploadMap[modalKey];
  //   if (cancelValue === 'done') {
  //     setIswaiting(false);
  //     resetCancelUploadFor(modalKey);
  //     handleShowModal();
  //     setOpacityHandle(false);
  //   }
  // }, [cancelUploadMap[modalKey]]);

  // useEffect(() => {
  //   const cancelValue = cancelUploadMap[modalKey];

  //   // ✅ Only close modal when the upload was canceled because the modal itself was closed
  //   if (cancelValue === "done") {
  //     setIswaiting(false);
  //     resetCancelUploadFor(modalKey);
  //     handleShowModal(); // closes modal
  //     setOpacityHandle(false);
  //   }
  // }, [cancelUploadMap[modalKey]]);

  useEffect(() => {
    const cancelValue = cancelUploadMap[modalKey];

    // if (cancelValue === 'done') {
    //   setIswaiting(false);
    //   resetCancelUploadFor(modalKey);
    //   handleShowModal(); // now it actually closes modal
    //   setOpacityHandle(false);
    // }
    if (cancelValue === 'done') {
      resetCancelUploadFor(modalKey); // make sure next upload works
      setIswaiting(false);

      setOpacityHandle(false);
      setTimeout(() => {
        handleShowModal();
      }, 10);
    }
  }, [cancelUploadMap[modalKey]]);

  return (
    <div
      className={`${!opacityHandle ? styles.wrapper : styles.wrapper2} ${extrawrapperstyle} ${styles.overlay}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          if (isWaiting) {
            if (modalKey?.length != 0) {
              cancelUploadFor(modalKey, 'closeModal');
            } else {
              handleShowModal();
            }
          } else {
            handleShowModal();
          }
        }
      }}
    >
      <div className={`${styles.content}  ${extraContentStyle}`}>
        <div className={`${styles.header} ${extraHeaderStyle}`}>
          <div className={styles.titleContainer}>
            {modalIcon}
            <div
              className={`${styles.titleStyle} ${modalIcon && styles.titleMargin} ${styles[dir]}`}
            >
              {title}
            </div>
          </div>

          {/* <ToolbarIcons.CloseIcon
            className={styles.closeIcon}
            onClick={() => {
              if (isWaiting) {
                cancelUploadFor(modalKey, 'closeModal');
              } else {
                handleShowModal();
                setOpacityHandle(false);
              }
            }}
          /> */}
          <span
            className={`${styles.closeIconWrapper}`}
            onClick={() => {
              if (isWaiting) {
                if (modalKey?.length != 0) {
                  // Only trigger cancellation because modal is closing
                  cancelUploadFor(modalKey, 'closeModal');
                } else {
                  // handleShowModal(); // just close modal
                  setTimeout(() => {
                    handleShowModal();
                  }, 10);
                  setOpacityHandle(false);
                }
              } else {
                handleShowModal(); // just close modal
                setOpacityHandle(false);
              }
            }}
          >
            <ToolbarIcons.CloseIcon width="18px" height="18px" />
          </span>
        </div>

        <div className={`${styles.contentInside} ${extraContentInsideClass}`} id={contentId}>
          {text && <p className={`${styles.modalText}`}>{text}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
